export default {"src":"/_next/static/media/profileGreyNewSelected.2e38cac0.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};